import {useContext} from 'react'

import {FormContactSellerContext} from '../useContactSellerState/index.js'

const useContactSellerFormContext = () => {
  const {state, dispatch, currentProps, actions} = useContext(FormContactSellerContext)

  return {state, dispatch, currentProps, actions}
}

export default useContactSellerFormContext
